/* Display units follow the Shopify country selection; variant IDs and order data stay intact. */
(() => {
  if (window.EvolvedMeasurements) return;
  const imperialFirst = document.documentElement.dataset.evCountry === 'US';
  const number = String.raw`\d+(?:\.\d+)?`;
  const unit = String.raw`(?:millimeters?|centimeters?|meters?|millimetres?|centimetres?|metres?|inches|inch|feet|foot|mm|cm|kg|lbs?|oz|ft|in|g|m|["″])`;
  const atom = `${number}(?:\\s*${unit}(?![A-Za-z]))?`;
  const measure = `${atom}(?:\\s*(?:×|x|–|-|to)\\s*${atom}){0,3}`;
  const unitPattern = new RegExp(`${unit}(?![A-Za-z])`, 'g');
  const definitions = {
    mm: {kind:'length', system:'metric', factor:.001, other:'in'},
    cm: {kind:'length', system:'metric', factor:.01, other:'in'},
    m: {kind:'length', system:'metric', factor:1, other:'ft'},
    in: {kind:'length', system:'imperial', factor:.0254, other:'cm'},
    ft: {kind:'length', system:'imperial', factor:.3048, other:'m'},
    g: {kind:'weight', system:'metric', factor:.001, other:'oz'},
    kg: {kind:'weight', system:'metric', factor:1, other:'lb'},
    oz: {kind:'weight', system:'imperial', factor:.028349523125, other:'g'},
    lb: {kind:'weight', system:'imperial', factor:.45359237, other:'kg'}
  };
  function canonical(value) {
    if (/^(inches|inch|["″])$/.test(value)) return 'in';
    if (/^(feet|foot)$/.test(value)) return 'ft';
    if (/^lbs?$/.test(value)) return 'lb';
    if (/^milli/.test(value)) return 'mm';
    if (/^centi/.test(value)) return 'cm';
    if (/^met/.test(value)) return 'm';
    return value;
  }
  function parse(value) {
    const units = [...value.matchAll(new RegExp(unitPattern.source, 'g'))].map(match => canonical(match[0]));
    if (!units.length || units.some(value => value !== units[0])) return null;
    const info = definitions[units[0]];
    if (!info) return null;
    const quantity = value.replace(new RegExp(unitPattern.source, 'g'), '').replace(/\s+/g, ' ').trim();
    return {...info, unit:units[0], quantity};
  }
  function display(parsed) { return `${parsed.quantity} ${parsed.unit}`; }
  function convert(parsed) {
    const target = definitions[parsed.other];
    const quantity = parsed.quantity.replace(new RegExp(number, 'g'), raw => {
      const value = Number(raw) * parsed.factor / target.factor;
      const digits = parsed.other === 'ft' ? 1 : value > 0 && value < .1 ? 3 : 2;
      return String(Number(value.toFixed(digits)));
    });
    return {...target, quantity, unit:parsed.other};
  }
  function ordered(a, b, modifier = '', us = imperialFirst) {
    const first = a.system === (us ? 'imperial' : 'metric') ? a : b;
    const second = first === a ? b : a;
    return `${display(first)}${modifier} (${display(second)})`;
  }
  function format(text, us = imperialFirst) {
    const pairs = [];
    const paired = new RegExp(`(${measure})(\\s+(?:thin|thick))?\\s*(?:\\(\\s*≈?\\s*(${measure})\\s*\\)|/\\s*(${measure}))`, 'g');
    let result = text.replace(paired, (match, left, modifier, bracketed, slashed) => {
      const a = parse(left), b = parse(bracketed || slashed);
      if (!a || !b || a.kind !== b.kind || a.system === b.system) return match;
      pairs.push(ordered(a, b, modifier || '', us));
      return `\uE000${pairs.length - 1}\uE001`;
    });
    result = result.replace(new RegExp(measure, 'g'), match => {
      const parsed = parse(match);
      return parsed ? ordered(parsed, convert(parsed), '', us) : match;
    });
    return result.replace(/\uE000(\d+)\uE001/g, (_, index) => pairs[Number(index)]);
  }
  window.EvolvedMeasurements = {format, imperialFirst};

  const originals = new WeakMap();
  const rendered = new WeakMap();
  function formatElement(element) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.parentElement?.closest('script,style,svg,button,input,select,[data-ev-unit-skip]')) continue;
      if (!originals.has(node) || node.textContent !== rendered.get(node)) originals.set(node, node.textContent);
      const original = originals.get(node);
      const updated = format(original);
      rendered.set(node, updated);
      if (node.textContent !== updated) node.textContent = updated;
    }
  }
  let frame;
  function update() {
    document.querySelectorAll('.ev-specs tr').forEach(row => {
      const label = row.querySelector('th')?.textContent || '';
      // Screen/model names and standardized ports keep their conventional units.
      if (/audio|headphone|port|connector|wi-?fi|screen size|watch model|iphone model|ipad model/i.test(label)) return;
      const cell = row.querySelector('td');
      if (cell) formatElement(cell);
    });
    document.querySelectorAll('[data-ev-measurement]').forEach(formatElement);
  }
  function schedule() { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }
  function start() {
    update();
    const scope = document.querySelector('main');
    if (!scope) return;
    const observer = new MutationObserver(schedule);
    observer.observe(scope, {childList:true, subtree:true, characterData:true});
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('variant:change', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
